<template>
  <section class="text-center mx-auto">
    <div class="flex flex-col">
      <button-option
        v-for="(option, index) in $store.state.data.Steps[
          $store.state.activeStep
        ].Options"
        :isActive="isActiveStep(index)"
        :key="option.Id"
        @click.native="
          if (isNewWindowOpened(option)) {
            return;
          }
          setSelectedTile(index);
          startFlow(option);
        "
      >
        {{ option.Title }}
        <template
          v-slot:tooltip
          v-if="option.TooltipTitle && option.TooltipBody"
        >
          <tooltip :settings="option" />
        </template>
      </button-option>
    </div>
  </section>
</template>
<script>
import ButtonOption from "../shared/ButtonOption";
import Tooltip from "../shared/Tooltip";
import { mapGetters } from "vuex";

export default {
  components: {
    ButtonOption,
    Tooltip
  },
  data() {
    return {
      data1: ""
    };
  },
  computed: {
    ...mapGetters([
      "getActiveStepId"
    ]),
  },
  methods: {
    isNewWindowOpened(option) {
      if (option
        && option.Link
        && option.Link.Url) {
          if (option.Link.Target) {
            window.open(option.Link.Url, option.Link.Target);
          } else {
            window.location = option.Link.Url;
          }
          return true;
      }
      return false;
    },
    startFlow(option) {
      const flowData = {
        [this.$store.state.data.Steps[this.getActiveStepId]
          .SalesforcePropertyKey]: option.SalesforcePropertyValue
      };

      this.updateUserInput(flowData);

      const id = option.FlowSelected;
      const data = this.$store.state.data;
      const currentId = id.replace(/[{}]/g, "").toLowerCase();
      const stepName =
        data.Flows[currentId][this.$store.state.currentActiveIndex];

      if (data && data.Steps && stepName) {
        this.$store.commit("setActiveTemplate", data.Steps[stepName].StepType);
        this.$store.commit("setActiveStepName", stepName);
        this.$store.commit("setActiveFlow", currentId);
        this.$store.commit("setActiveFlowType", option.SalesforcePropertyValue);
      }
    },
    updateUserInput(value) {
      this.$store.commit("updateUserInput", value);
    },
    setSelectedTile(index) {
      this.$store.commit("setSelectedTileIndex", index);
      this.$store.commit("setActiveSelection");
    },
    isActiveStep(index) {
      const selectedKey = this.$store.state.activeSelection[this.getActiveStepId];
      return (selectedKey == index) ? true : false;
    }
  }
};
</script>
